export const regionFilter = (regionString: string) => !!regionString;
